import AbstractItemResource from '../abstract/abstract-item-resource';
import {Resource, Uid} from 'sdk/src/defines';
import {CastRule, CastType} from '../../utility/types';

class ContentCategory extends AbstractItemResource {
    public resourceType: Resource = Resource.CONTENT_CATEGORIES;

    public declare categoryId: string;

    public declare order: number;

    public declare content: {
        title: string,
        id: Uid,
    };

    public castValues(): CastType {
        return {
            order: CastRule.FLOAT,
        };
    }
}

export default ContentCategory;
